import Vue from 'vue';

const notProduction = process.env.NODE_ENV !== 'production';

// initial state
const state = {
	showHeading: false,
	showManchet: false,
	showContent: false,
	showLogo: false,
	showIndexLocation: false,
	showPurchaseSumCalculator: false,
};

// actions
const actions = {
	show({commit}) {
		commit('updateData', {
			name: 'showHeading',
			value: true,
		});
		setTimeout(() => {
			commit('updateData', {
				name: 'showManchet',
				value: true,
			});
		}, 200);
		setTimeout(() => {
			commit('updateData', {
				name: 'showContent',
				value: true,
			});
		}, 400);
		setTimeout(() => {
			commit('updateData', {
				name: 'showLogo',
				value: true,
			});
		}, 600);
		setTimeout(() => {
			commit('updateData', {
				name: 'showIndexLocation',
				value: true,
			});
		}, 800);
	},
	hide({commit}) {
		commit('updateData', {
			name: 'showHeading',
			value: false,
		});
		commit('updateData', {
			name: 'showManchet',
			value: false,
		});
		commit('updateData', {
			name: 'showContent',
			value: false,
		});
		commit('updateData', {
			name: 'showLogo',
			value: false,
		});
		commit('updateData', {
			name: 'showIndexLocation',
			value: false,
		});
	}
};

// mutations
const mutations = {
	updateData(state, payload) {
		if (notProduction) {
			console.log(payload.name, payload.value);
		}
		Vue.set(state, payload.name, payload.value);
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
};


// WEBPACK FOOTER //
// ./assets/_js/store/modules/content.js